export default __webpack_public_path__ + "static/media/ar-cavalieri.b864db92.jpg";